import { $ } from 'utils/dom';
import ScrollClassToggler from 'modules/scroll-class-toggler';

const badge = $('.badge');
const classToAdd = 'badge--is-hidden';

if (badge) {
  const toggleLogoClass = new ScrollClassToggler(badge, classToAdd, 50, 50);

  toggleLogoClass.init();
}
